import { render, staticRenderFns } from "./ModalSubscriptionConfirmation.vue?vue&type=template&id=2530a06b&scoped=true&"
import script from "./ModalSubscriptionConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalSubscriptionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubscriptionConfirmation.vue?vue&type=style&index=0&id=2530a06b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530a06b",
  null
  
)

export default component.exports